export class DwellClock {
    constructor({ now = () => Date.now() } = {}) {
        this.now = now
        this.accrued = 0
        this.runningSince = null
    }

    get elapsed() {
        return this.runningSince == null
            ? this.accrued
            : this.accrued + (this.now() - this.runningSince)
    }

    start() {
        this.resume()
    }

    resume() {
        if (this.runningSince != null) {
            return
        }

        this.runningSince = this.now()
    }

    pause() {
        if (this.runningSince == null) {
            return
        }

        this.accrued += this.now() - this.runningSince
        this.runningSince = null
    }

    stop() {
        this.pause()
    }
}
